import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { DETECTION_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const LOAD_LIST = '_LOAD_LIST';

export const loadDetectionList = createDeferredAction(DETECTION_MODULE + LOAD_LIST);
export const loadDetectionListSuccessful = createAction(DETECTION_MODULE + LOAD_LIST + SUCCESSFUL);
export const loadDetectionListFailed = createAction(DETECTION_MODULE + LOAD_LIST + FAILED);
